export const VARIANT_REGEX =
  /@(?<variantPair>(?<variant>[^.]+).(?<value>[^.]+)[.])/g;
